import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Setting1"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.00897 10.5163C6.62323 10.5163 5.49977 9.39296 5.49977 8.00705C5.49977 6.62115 6.62323 5.49782 8.00897 5.49782C9.39471 5.49782 10.5182 6.6213 10.5182 8.00705C10.5182 9.39296 9.39471 10.5163 8.00897 10.5163ZM12.2956 6.46873C12.2457 6.32938 12.191 6.19496 12.1313 6.06546L13.1768 4.67642C13.3079 4.49794 13.289 4.2503 13.132 4.09392L11.9222 2.88411C11.7658 2.72729 11.5182 2.70817 11.3397 2.83931L9.95067 3.88482L9.5474 3.72052L9.30843 1.98796C9.27826 1.76407 9.08633 1.59768 8.86036 1.59963H7.15768C6.93185 1.59768 6.73963 1.76407 6.70961 1.98796L6.47064 3.72052L6.06737 3.88482L4.67835 2.83931C4.49972 2.70817 4.25223 2.72729 4.09585 2.88411L2.88606 4.09392C2.72923 4.2503 2.71011 4.49794 2.84125 4.67642L3.88675 6.06546C3.82701 6.19496 3.77219 6.32938 3.72246 6.46873L1.98991 6.70771C1.76602 6.73788 1.59949 6.92995 1.60158 7.15578V8.85848C1.59949 9.08446 1.76602 9.27638 1.98991 9.30655L3.70752 9.54553C3.75726 9.68488 3.81207 9.8193 3.87182 9.9488L2.82631 11.3378C2.69518 11.5163 2.7143 11.764 2.87112 11.9203L4.08092 13.1301C4.23729 13.287 4.48493 13.3061 4.66341 13.175L6.05244 12.1294L6.4557 12.2937L6.69467 14.0114C6.72469 14.2353 6.91692 14.4018 7.14275 14.3997H8.86036C9.08633 14.4018 9.27826 14.2353 9.30843 14.0114L9.5474 12.2937L9.95067 12.1294L11.3397 13.175C11.5182 13.3061 11.7658 13.287 11.9222 13.1301L13.132 11.9203C13.289 11.764 13.3079 11.5163 13.1768 11.3378L12.1313 9.9488C12.191 9.8193 12.2457 9.68488 12.2956 9.54553L14.0132 9.30655C14.2371 9.27638 14.4035 9.08446 14.4015 8.85848V7.15578C14.4045 6.93488 14.246 6.7446 14.0281 6.70771L12.2956 6.46873Z",
  fill: "#737E99"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var setting1 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { setting1 as default };
